module.exports = __webpack_public_path__ + "static/media/bhim.c18f1fe9.png";